import React from 'react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Box } from '@fiverr-private/theme';
import pathfinder from '@fiverr-private/pathfinder';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import SafeComponent from '../../../logged_out_homepage/shared/SafeComponent';
import {
    BQ_CLICKED_QUALITY_EXPERTS_BANNER,
    BQ_IMP_QUALITY_EXPERTS_BANNER_IS_SHOWN,
} from '../../../logged_out_homepage/utils/biEvents/events/bigQueryEvents';
import { getImpressionEnrichment, sendBigQueryEvent } from '../../../logged_out_homepage/utils/biEvents';
import styles from './styles.module.scss';

const QualityExpertsBanner = () => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_QUALITY_EXPERTS_BANNER_IS_SHOWN }));

    const pathToJoin = pathfinder('join', undefined, { query: { source: 'quality_experts_banner' } });

    const onSignUpButtonClick = async (event) => {
        event.preventDefault();

        sendBigQueryEvent({ eventName: BQ_CLICKED_QUALITY_EXPERTS_BANNER });
        await triggerSignUp({
            modalOptions: {
                triggerType: 'user_trigger',
                triggerId: 'quality_experts_banner',
            },
        });
    };

    return (
        <Section paddingTop="0" paddingBottom="0">
            <Stack
                display="flex"
                direction="column"
                alignItems="center"
                paddingY="10"
                paddingX="9"
                marginBottom="10"
                borderRadius="2xl"
                className={styles.container}
                ref={ref}
            >
                <Typography
                    style={{ fontWeight: 200 }}
                    fontSize="h_3xl"
                    color="white"
                    textAlign="center"
                    maxWidth="810px"
                    lineHeight="h_3xl"
                    fontFamily="primary"
                    letterSpacing="-0.03em"
                >
                    <I18n
                        k="logged_out_homepage.de.quality_experts_banner.title"
                        templates={{
                            em: (text) => (
                                <Box as="em" color="green_700" fontFamily="domaine" fontStyle="normal">
                                    {text}
                                </Box>
                            ),
                        }}
                    />
                </Typography>
                <Button variant="filled" colorScheme="white" size="sm" href={pathToJoin} onClick={onSignUpButtonClick}>
                    <I18n k="logged_out_homepage.de.quality_experts_banner.cta" />
                </Button>
            </Stack>
        </Section>
    );
};

export default SafeComponent(QualityExpertsBanner);
